class RAMQRepresentant {
    public FirstName: string;
    public LastName: string;
    public NAM: string;
    public Type: string; // ACC => Accompagnateur     // CUR => Curateur    // MAN => Mandataire    // MOP => Mere ou pere    // TUT => Tuteur
}

export { RAMQRepresentant };
